import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 8, viewBox: "0 0 5 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L4 4L1 7", stroke: "#0057B8", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowRight;
